<template>
  <b-modal
    id="modalCreateEditSetor"
    size="xl"
    :title="textModal"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal', false)"
  >
    <form @submit.prevent="save">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label>Descrição: <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.setor.descricao.$error }"
            placeholder="Descrição do setor"
            v-model="$v.setor.descricao.$model"
          />
          <span v-if="!$v.setor.descricao.required" class="invalid-feedback">
            O campo é obrigatório
          </span>
          <span v-if="!$v.setor.descricao.minLength" class="invalid-feedback">
            A descrição deve possuir pelo menos 3 caracteres
          </span>
        </div>
      </div>
      <div v-if="setorId" class="form-row">
        <div class="form-group col-sm-6">
          <p>Status: <span class="text-danger">*</span></p>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusInativo"
              value="0"
              v-model="setor.status"
            />
            <label class="form-check-label" for="statusInativo">
              Inativo
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusAtivo"
              value="1"
              v-model="setor.status"
            />
            <label class="form-check-label" for="statusAtivo"> Ativo </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn btn-secondary"
          title="Cancelar"
          @click="$emit('closeModal', false)"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :title="textModal"
          :disabled="$v.$invalid || disableButton"
        >
          <i
            v-if="disableButton"
            class="spinner-grow spinner-grow-custom text-wither"
          />
          <span v-else>{{ textModal }}</span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateEditSetorModal',
  props: {
    setorId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      setor: {
        descricao: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.setorId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getSetor() {
      try {
        this.setor = await this.$store.dispatch('getSetor', this.setorId)
        this.$bvModal.show('modalCreateEditSetor')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.setorId) {
            response = await this.$store.dispatch('updateSetor', this.setor)
          } else {
            response = await this.$store.dispatch('saveSetor', this.setor)
          }
          this.disableButton = false
          this.$root.$bvToast.toast(response.message, {
            title: 'Sucesso!',
            variant: 'success',
            solid: true,
          })
          this.$emit('closeModal', true)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$bvToast.toast(error.message, {
              title: 'Atenção!',
              variant: 'warning',
              solid: true,
            })
          } else {
            this.$root.$bvToast.toast(
              'Não foi possível se conectar ao servidor.',
              {
                title: 'Erro!',
                variant: 'danger',
                solid: true,
              },
            )
          }
        }
      }
    },
  },

  validations: {
    setor: {
      descricao: {
        required,
        minLength: minLength(3),
      },
    },
  },

  mounted() {
    if (this.setorId) {
      this.getSetor()
    } else {
      this.$bvModal.show('modalCreateEditSetor')
    }
  },
}
</script>
